/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as sportsAction from 'app/shared/store/actions/sports.action';
import * as fromServices from 'app/shared/services/';

@Injectable()
export class SportsEffects {
  getSports$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sportsAction.GET_SPORTS),
      switchMap((action: sportsAction.GetSports) => {
        return this.sportsService.getAllSports().pipe(
          map((response: any) => new sportsAction.GetSportsSuccess(response.sports)),
          catchError((error) => of(new sportsAction.GetSportsFail(error.message)))
        );
      })
    )
  );

  constructor(private actions$: Actions, private sportsService: fromServices.SportsService) {}
}
